import { useQuery } from "@tanstack/react-query";
import { getProductById } from "../api";

export const useGetProductById = (id: string) => {
  const { data, isLoading } = useQuery({
    queryKey: ["PRODUCT_ID", id],
    queryFn: () => getProductById(id),
    select: ({ data }) => data,
    enabled: !!id,
  });
  return { product: data, isLoading };
};
